export enum MacroComponentEvents {
  ALL_WIDGETS_LOADED = 'allWidgetsLoaded',
}
